module.exports = __webpack_public_path__ + "fonts/darwin-black-webfont.fca44c3.ttf";